import * as React from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { GetDeveloperPayouts } from '../../../types/generated';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import { DATE_FORMAT } from './PayoutList';
import format from 'date-fns/format';
import Button from '@material-ui/core/Button';
import { useNavigate } from 'react-router-dom';
import { UnclaimedPayoutMessage } from '../../../components/UnclaimedPayoutMessage';
import { useOrganizationStatus } from '../../../queries/useOrganizationStatus';
import { useEffect } from 'react';

interface PayoutListProps {
    data: GetDeveloperPayouts;
}

export function PayoutListView({ data }: PayoutListProps) {
    const navigate = useNavigate();
    const {
        hasValidPayoutSettings,
        hasValidTaxForm,
        hasUnclaimedPayout,
        periodFrom,
        periodTo,
        displayAmount,
        refetch: refetchStatus,
    } = useOrganizationStatus();

    useEffect(() => {
        refetchStatus();
    }, [refetchStatus]);

    const openPayoutRequest = (id: string) => {
        navigate('/extranet/payouts/request/' + id);
    };

    const onCreate = () => {
        navigate('/extranet/payouts/request/create');
    };

    return (
        <Paper>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Period</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                {hasUnclaimedPayout && periodFrom && periodTo && displayAmount && (
                    <TableBody>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <UnclaimedPayoutMessage
                                    amount={displayAmount}
                                    periodFrom={periodFrom}
                                    periodTo={periodTo}
                                    action={
                                        (hasValidTaxForm && hasValidPayoutSettings && onCreate) ||
                                        undefined
                                    }
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                )}
                {(!data || data.getPayouts.edges.length === 0) && (
                    <TableBody>
                        <TableRow>
                            <TableCell colSpan={4}>
                                <Alert severity={'info'}>
                                    <Typography>No payouts have been requested.</Typography>
                                </Alert>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                )}
                {data.getPayouts.edges.map(edge => {
                    const node = edge.node;
                    const df = new Date(node.invoiceDateFrom);
                    const dt = new Date(node.invoiceDateTo);

                    return (
                        <TableBody key={node.id}>
                            <TableRow>
                                <TableCell>
                                    {format(df, DATE_FORMAT)} - {format(dt, DATE_FORMAT)}
                                </TableCell>
                                <TableCell>{node.status}</TableCell>
                                <TableCell>{node.amount}</TableCell>
                                <TableCell align={'right'}>
                                    {node.status === 'REJECTED' && (
                                        <Button onClick={() => openPayoutRequest(node.id)}>
                                            Edit
                                        </Button>
                                    )}
                                    {node.status === 'PAID' && (
                                        <Button href={node.pdfInvoiceUrl} target={'_blank'}>
                                            View invoice
                                        </Button>
                                    )}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    );
                })}
            </Table>
        </Paper>
    );
}
